import { FC } from 'react'

import useSWR from 'swr'

import Icon from '@/components/Icon'
import { isSuccess } from '@/axios'
import { suggestKeywords } from '@/api'

import { cn } from '@/utils'

export interface ITrendingProps {
  handleSearchTrending: (val: string) => void
  setHistoryStorage: (val: string) => void
}

const Trending: FC<ITrendingProps> = (props) => {
  const { handleSearchTrending, setHistoryStorage } = props

  const { data } = useSWR(
    '/search/suggestKeywords',
    async () => {
      const resp = await suggestKeywords()
      if (isSuccess(resp)) {
        return resp
      }
      return undefined
    },
    {
      revalidateIfStale: false,
    },
  )

  return (
    <div>
      <div>
        {data?.data.list?.map((item, index) => {
          return (
            <>
              <div
                key={`${item}-${index}`}
                className={cn('mb-[37px] flex cursor-pointer items-center px-[37px]')}
                onClick={() => {
                  setHistoryStorage(item)
                  handleSearchTrending(item)
                }}
              >
                <Icon name='Hot' className='mr-[7px] h-[30px] w-[30px]' />
                <p className='m-0 line-clamp-1 h-[41px] break-all font-geologica text-[26px] font-normal leading-[41px] text-base-text-color'>
                  {item}
                </p>
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}

export default Trending
